import { useState } from 'react';
import { api, apiError } from '../../../shared/api.js';
import { toast } from '../../../shared/useToast.js';
import { Icon } from '../../../layout/Icon.jsx';

function rowsToCSV(rows) {
  if (!rows?.length) return '';
  const headers = Object.keys(rows[0]);
  const escape = (v) => {
    if (v == null) return '';
    const s = String(v);
    if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
  };
  const lines = [headers.join(',')];
  for (const r of rows) {
    lines.push(headers.map((h) => escape(r[h])).join(','));
  }
  return lines.join('\n');
}

function todayStamp() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}${m}${day}`;
}

export function BulkExportButton() {
  const [busy, setBusy] = useState(false);

  async function exportCsv() {
    setBusy(true);
    try {
      const { data } = await api.get('/catalog/products/export');
      const items = data?.items || [];
      if (!items.length) {
        toast.warning('لا توجد منتجات للتصدير');
        return;
      }
      const csv = rowsToCSV(items);
      const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `products-${todayStamp()}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.success(`تم تصدير ${items.length} منتج`);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <button type="button" className="btn" onClick={exportCsv} disabled={busy}>
      <Icon name="print" size={14} /> {busy ? 'جاري التصدير...' : 'تصدير CSV'}
    </button>
  );
}
